// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1Th-X","noInteraction":"EventWrapper_noInteraction__Akucd","pointerPassthrough":"EventWrapper_pointerPassthrough__1hsR_"};